import { Divider, Heading } from '@chakra-ui/react';
import React, { useState } from 'react';

import { GraphProvider } from '../hooks/bbplMonitorContext';
import { BBPLMonitorParams } from '../types/bbplMonitorTypes';
import { BBPLMonitorOptions } from './BBPLMonitorOptions';
import { GraphRenderer } from './GraphRenderer';

export const BBPLMonitorForOrganization: React.FC<{
  organizationId: string;
}> = ({ organizationId }) => {
  const [
    bbplMonitorParams,
    setBbplMonitorParams,
  ] = useState<BBPLMonitorParams | null>(null);

  return (
    <>
      <BBPLMonitorOptions
        initialParams={bbplMonitorParams}
        organizationId={organizationId}
        onChange={setBbplMonitorParams}
      />
      {bbplMonitorParams && (
        <GraphProvider params={bbplMonitorParams}>
          <GraphRenderer />
        </GraphProvider>
      )}
      <Divider />

      {!bbplMonitorParams && <Heading as="h3">No Params!</Heading>}
    </>
  );
};

export const BBPLMonitor = ({ organizationId }: { organizationId: string }) => {
  return <BBPLMonitorForOrganization organizationId={organizationId} />;
};
